import { useEffect, useState } from "react";
import axios from "axios";
import { Card } from "../../styles";
import { useAuth } from "../../../../../hooks/auth";
import DeleteAlert from "../deleteAlert";
import { toast } from "react-toastify";

import { IoArrowBack, IoSearch, IoTrash } from "react-icons/io5";
import { FaCheck } from "react-icons/fa";
import { AiOutlineUser } from "react-icons/ai";
import { PiIdentificationBadge } from "react-icons/pi";
import { TbEditCircle } from "react-icons/tb";

export default function EditProject({ projeto, setStatus }) {
  const [name, setName] = useState(projeto.nome || "");
  const [cnpj, setCnpj] = useState(projeto.cnpj);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [sortedUsers, setSortedUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [searchedUser, setSearchedUser] = useState(null);
  const [searchedUsers, setSearchedUsers] = useState([]);

  const { token, user } = useAuth();

  // Filtra usuários com base no termo de pesquisa
  const filteredUsers = sortedUsers.filter((user) =>
    user.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    console.log("Project users:", projeto.users);

    // Initialize sorted users from project
    const initialSortedUsers = projeto.users
      .filter((user) => user.cargo !== "god")
      .sort((a, b) => a.name.localeCompare(b.name));

    setSortedUsers(initialSortedUsers);

    // Initialize selected users with their IDs
    const initialSelectedIds = initialSortedUsers.map((user) => user._id);
    setSelectedUsers(initialSelectedIds);

    console.log("Initial sorted users:", initialSortedUsers);
    console.log("Initial selected IDs:", initialSelectedIds);
  }, [projeto.users]);

  function handleAlert(item, type) {
    setItemToDelete({ ...item, type });
    setShowAlert(true);
  }

  function handleCloseAlert() {
    setShowAlert(false);
    setItemToDelete(null);
  }

  const handleUsersFromProject = async (email) => {
    try {
      const response = await axios.post(
        `https://dev.vidal-app.com/users/email`,
        { email },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            projeto: projeto._id,
            user: user._id,
          },
        }
      );

      // Verifica se a resposta é um array e possui resultados
      if (Array.isArray(response.data) && response.data.length > 0) {
        setSearchedUsers(response.data);
        console.log("Usuários encontrados:", response.data);
      } else {
        console.error("Nenhum usuário encontrado.");
        setSearchedUsers([]);
      }
    } catch (error) {
      console.error("Erro ao buscar usuário:", error);
    }
  };

  const handleDelete = async () => {
    console.log(`Projeto ${itemToDelete?.nome || "Desconhecido"} excluído!`);
    handleCloseAlert();
  };

  const submit = async () => {
    try {
      const data = {
        projectData: {},
        usersIds: selectedUsers, // Changed from userIds to usersIds to match backend
      };

      if (name !== projeto.nome) {
        data.projectData.nome = name;
      }

      console.log("Submitting data:", {
        url: "https://dev.vidal-app.com/projetos/update-project",
        projectId: projeto._id,
        userId: user._id,
        data,
      });

      const response = await axios.put(
        "https://dev.vidal-app.com/projetos/update-project",
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            projeto: projeto._id, // Make sure we're sending the project ID
            user: user._id, // Make sure we're sending the user ID
          },
        }
      );

      toast.success("Usuários atualizados com sucesso!");
      setTimeout(() => {
        setStatus("list");
      }, 2000); // Fecha após 2 segundos
      console.log("Update response:", response.data);
    } catch (err) {
      toast.error(`Erro ao atualizar usuários`);
      console.error("Erro ao atualizar o projeto:", err);
    }
  };

  const handleSelectUser = (user) => {
    setSelectedUsers((prevSelectedUsers) => {
      const isSelected = prevSelectedUsers.includes(user._id);
      if (isSelected) {
        return prevSelectedUsers.filter((id) => id !== user._id);
      } else {
        return [...prevSelectedUsers, user._id];
      }
    });

    // Se o usuário buscado não estiver na lista local, adicione-o
    if (!sortedUsers.some((u) => u._id === user._id)) {
      setSortedUsers((prevSortedUsers) =>
        [...prevSortedUsers, user].sort((a, b) => a.name.localeCompare(b.name))
      );
    }
    // Limpa os resultados da busca e o termo, se necessário
    setSearchTerm("");
    setSearchedUsers([]);
  };

  useEffect(() => {
    if (searchTerm) {
      const delayDebounceFn = setTimeout(() => {
        handleUsersFromProject(searchTerm);
      }, 500);

      return () => clearTimeout(delayDebounceFn);
    } else {
      setSearchedUsers([]);
    }
  }, [searchTerm]);

  return (
    <Card>
      <div className="header">
        <div className="btn" onClick={() => setStatus("list")}>
          <IoArrowBack />
        </div>
        <TbEditCircle />
        <p>Editando projeto</p>
      </div>
      <div className="display">
        <div className="item ativ">
          <div className="thumb">
            <div className="circle" style={{ backgroundColor: projeto.color }}>
              <p>{projeto.nome.slice(0, 1)}</p>
            </div>
          </div>
          <div className="content">
            <p>{projeto.nome}</p>
            <p className="email">{projeto.cnpj}</p>
            <IoTrash onClick={() => handleAlert(projeto, "project")} />
          </div>
        </div>
        <div className="tag">
          <PiIdentificationBadge />
          <p>informações</p>
        </div>

        <div className="input">
          <AiOutlineUser />
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Nome do projeto"
          />
        </div>

        <div className="input">
          <input value={projeto.cnpj} readOnly />
        </div>
        <div className="tag">
          <PiIdentificationBadge />
          <p>Usuários</p>
        </div>

        <div className="search">
          <IoSearch />
          <input
            placeholder="Digite o nome do usuário"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="display">
          {filteredUsers.map((user) => {
            const isSelected = selectedUsers.includes(user._id);
            return (
              <div
                className="card"
                key={user._id}
                onClick={() => handleSelectUser(user)}
                style={{ opacity: isSelected ? 1 : 0.4 }}
              >
                <div className="thumb">
                  <div
                    className="circle"
                    style={{ backgroundColor: user.color }}
                  >
                    <p>{user.name.charAt(0).toUpperCase()}</p>
                  </div>
                </div>
                <div className="content">
                  <p>{user.name}</p>
                  <p>{user.email}</p>
                </div>
                <div
                  className="check"
                  style={{ color: isSelected ? "green" : "gray" }}
                >
                  <FaCheck />
                </div>
              </div>
            );
          })}
          {searchedUsers.map((user) => {
            // Se o usuário já estiver na lista local, você pode optar por não exibi-lo novamente
            const alreadyIncluded = sortedUsers.some((u) => u._id === user._id);
            if (alreadyIncluded) return null;

            const isSelected = selectedUsers.includes(user._id);
            return (
              <div
                className="card"
                key={user._id}
                onClick={() => handleSelectUser(user)}
                style={{ opacity: isSelected ? 1 : 0.4 }}
              >
                <div className="thumb">
                  <div
                    className="circle"
                    style={{ backgroundColor: user.color }}
                  >
                    <p>{user.name.charAt(0).toUpperCase()}</p>
                  </div>
                </div>
                <div className="content">
                  <p>{user.name}</p>
                  <p>{user.email}</p>
                </div>
                <div
                  className="check"
                  style={{ color: isSelected ? "green" : "gray" }}
                >
                  <FaCheck />
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="bottom">
        <div className="btn" onClick={submit}>
          <p>SALVAR</p>
        </div>

        <DeleteAlert
          show={showAlert}
          handleClose={handleCloseAlert}
          handleDelete={handleDelete}
        />
      </div>
    </Card>
  );
}
